import socketIO from 'socket.io-client';

const socket = socketIO('https://chat.alphalibertee.com', {
    autoConnect: false,
  });

export default socket;